import React from 'react';

import './GamePicker.scss';
import { GameType } from '../../Utils';

interface Props {
  gameType: GameType;
  onClick?: () => void;
}

export const GameCard = (props: Props) => {

  const getImg = () => {
    switch (props.gameType) {
      case GameType.Baccarat: return '/img/baccarat.svg';
      case GameType.SicBo: return '/img/sicbo.svg';
      case GameType.Roulette: return '/img/roulette.svg';
    }
  };

  const getClass = () => {
    switch (props.gameType) {
      case GameType.Baccarat: return 'baccarat';
      case GameType.SicBo: return 'sicbo';
      case GameType.Roulette: return 'roulette';
    }
  };

  const getAltName = () => {
    switch (props.gameType) {
      // case GameType.Baccarat: return '百家乐';
      // case GameType.SicBo: return '骰宝';
      // case GameType.Roulette: return '轮盘';
      case GameType.Baccarat: return '/img/baccarat_text_zn.svg';
      case GameType.SicBo: return '/img/sicbo_text_zn.svg';
      case GameType.Roulette: return '/img/roulette_text_zn.svg';
    }
  };

  const getName = () => {
    switch (props.gameType) {
      // case GameType.Baccarat: return 'Baccarat';
      // case GameType.Roulette: return 'Roulette';
      // case GameType.SicBo: return 'Sic Bo';
      case GameType.Baccarat: return '/img/baccarat_text_en.svg';
      case GameType.SicBo: return '/img/sicbo_text_en.svg';
      case GameType.Roulette: return '/img/roulette_text_en.svg';
    }
  };

  return (
    <div
      className={'select_game_card ' + getClass()}
      onClick={props.onClick}
    >
      <img src={getImg()} alt='game-img' className="game_image"/>
      <div className='game_name'>
        {/*<span className='game_text_alt'>{getAltName()}</span>*/}
        {/*<span className='game_text'>{getName()}</span>*/}
        <span className='game_text_alt'><img src={getAltName()} alt='game-img'/></span>
        <span className='game_text'><img src={getName()} alt='game-img'/></span>
      </div>
    </div>
  );
};
